"use client";

import * as React from "react";

const Login = ({ ...props }: React.ComponentProps<"svg">) => {
  return (
    <svg
      data-slot="media-login"
      data-testid="media-login"
      viewBox="0 0 525 566"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M76 238.475C76 273.078 94.3822 315.604 159.383 315.604"
        stroke="#AAAAAA"
        strokeOpacity="0.3"
        strokeWidth="100.893"
        strokeLinecap="round"
      />
      <path
        d="M471.5 53C481.499 129 356 110 446.5 104"
        stroke="#AAAAAA"
        strokeOpacity="0.3"
        strokeWidth="104.228"
        strokeLinecap="round"
      />
      <rect
        x="195.596"
        y="134.202"
        width="33.3531"
        height="231.804"
        fill="#FFE4E4"
        fillOpacity="0.7"
      />
      <rect
        x="145"
        y="285"
        width="34"
        height="246"
        fill="#FFE4E4"
        fillOpacity="0.7"
      />
      <rect
        x="260.134"
        y="195.071"
        width="35.0207"
        height="267.658"
        fill="#FFE4E4"
      />
      <rect
        x="456.912"
        y="235.095"
        width="34.1869"
        height="207.623"
        fill="#FFE4E4"
      />
      <rect x="326.339" y="75" width="34.1869" height="276.83" fill="#FFE4E4" />
      <path
        d="M158.739 294.448H225.824V213.682L336.625 97.5134H472.258"
        stroke="#FA777C"
        strokeWidth="7.50444"
        strokeLinecap="round"
        strokeDasharray="21.68 21.68"
      />
      <path
        d="M470.589 104.184C470.589 164.636 475.592 231.92 365.711 231.92C255.831 231.92 258.741 280.354 258.741 334.443C258.741 388.531 270.157 451.89 156.236 451.89L16 451.89"
        stroke="url(#paint0_linear_165_3240)"
        strokeWidth="31.6854"
        strokeLinecap="round"
      />
      <path
        d="M360.524 351.83C347.66 351.83 335.086 355.718 324.39 363.002C313.695 370.286 305.359 380.639 300.436 392.752C295.514 404.864 294.226 418.193 296.735 431.052C299.245 443.911 305.439 455.722 314.535 464.993C323.63 474.264 335.219 480.577 347.835 483.135C360.452 485.693 373.529 484.38 385.413 479.363C397.297 474.345 407.455 465.849 414.601 454.948C421.748 444.047 425.562 431.23 425.562 418.119L387.922 418.119C387.922 423.643 386.315 429.042 383.305 433.634C380.294 438.226 376.015 441.806 371.009 443.919C366.002 446.033 360.493 446.586 355.179 445.508C349.864 444.431 344.982 441.771 341.15 437.866C337.318 433.96 334.709 428.984 333.652 423.567C332.595 418.15 333.137 412.536 335.211 407.433C337.285 402.33 340.796 397.969 345.302 394.9C349.808 391.832 355.105 390.194 360.524 390.194L360.524 351.83Z"
        fill="url(#paint1_linear_165_3240)"
      />
      <path
        d="M425.145 382.682C438.256 382.682 451.072 378.794 461.974 371.51C472.875 364.226 481.371 353.873 486.389 341.761C491.406 329.648 492.719 316.319 490.161 303.46C487.603 290.602 481.29 278.79 472.019 269.519C462.748 260.248 450.937 253.935 438.078 251.377C425.219 248.819 411.89 250.132 399.778 255.149C387.665 260.167 377.312 268.663 370.028 279.564C362.744 290.466 358.856 303.282 358.856 316.393L397.22 316.393C397.22 310.87 398.858 305.47 401.926 300.878C404.995 296.286 409.356 292.707 414.459 290.593C419.561 288.479 425.176 287.926 430.593 289.004C436.01 290.081 440.986 292.741 444.892 296.646C448.797 300.552 451.457 305.528 452.534 310.945C453.612 316.362 453.059 321.977 450.945 327.079C448.832 332.182 445.252 336.543 440.66 339.612C436.068 342.68 430.668 344.318 425.145 344.318L425.145 382.682Z"
        fill="url(#paint2_linear_165_3240)"
      />
      <circle
        cx="162.053"
        cy="370.679"
        r="55.4495"
        transform="rotate(-91.2854 162.053 370.679)"
        fill="url(#paint3_radial_165_3240)"
      />
      <rect
        x="390"
        y="345.475"
        width="35"
        height="161"
        fill="#FFE4E4"
        fillOpacity="0.6"
      />
      <path
        d="M478.094 97.5134C369.339 97.5133 360.672 162.884 360.672 213.202C360.672 254.918 370.665 331.197 261.047 331.197C150.212 331.197 147.065 400.507 147.064 451.89V528.5"
        stroke="#FF0F0F"
        strokeWidth="5.00296"
        strokeLinecap="round"
      />
      <path
        d="M224.705 137.583C224.705 172.147 162.121 255.107 162.121 255.107C159.62 252.605 99.5381 172.147 99.5381 137.583C99.5381 103.02 127.558 75 162.121 75C196.685 75 224.705 103.02 224.705 137.583Z"
        fill="url(#paint4_linear_165_3240)"
      />
      <circle cx="162.492" cy="131.283" r="28.767" fill="white" />
      <circle cx="471.5" cy="97.9749" r="16.5" fill="#FF7B7F" />
      <g filter="url(#filter0_d_165_3240)">
        <path
          d="M437.176 303.154C437.802 308.695 444.431 332.571 443.013 340.783C441.595 348.962 419.037 362.648 419.037 362.648L415.904 348.632L428.403 336.397L425.04 313.18L437.176 303.154Z"
          fill="#A55F38"
        />
        <path
          d="M419.695 276.309C422.927 274.924 428.929 274.594 432.26 280.102C435.591 285.609 439.021 304.473 439.351 307.705C439.351 307.705 434.701 314.136 427.709 313.081L419.695 276.309Z"
          fill="#E4F2F2"
        />
        <path
          d="M422.862 530.18C422.862 530.18 423.125 532.621 423.851 535.721C424.445 538.128 424.544 541.228 421.872 542.118C419.168 542.976 416.101 542.712 414.353 540.37C412.21 537.468 411.055 533.841 407.955 531.005C404.954 528.3 401.228 525.233 400.172 520.913C399.183 517.021 399.809 514.581 402.481 514.185C405.845 513.691 411.187 516.527 413.924 518.538C415.903 519.957 422.862 530.18 422.862 530.18Z"
          fill="#3F3F41"
        />
        <path
          d="M391.995 541.492C391.995 541.492 392.193 544.592 392.39 547.065C392.588 549.539 393.446 553.463 392.654 555.31C391.863 557.124 387.806 558.476 383.024 558.443C379.924 558.41 373.922 560.818 371.779 562.664C368.745 565.303 361.753 566.358 357.664 565.072C353.541 563.786 348.99 561.873 348.298 559.993C347.605 558.113 349.749 557.157 359.774 552.573C369.8 547.989 377.187 544.823 381.079 539.513L391.995 541.492Z"
          fill="#3F3F41"
        />
        <path
          d="M425.303 476.887C423.588 463.762 420.884 455.979 420.884 455.979C420.884 455.979 422.203 437.939 422.862 420.823C423.621 401.399 430.349 384.316 425.039 368.815L365.116 382.139C365.116 382.139 368.744 459.573 369.535 468.939C369.964 474.018 370.129 479.097 372.24 490.672C374.977 505.711 379.429 541.46 379.429 541.46C385.761 545.154 392.027 541.493 392.027 541.493C392.027 541.493 393.643 497.895 393.214 487.045C392.72 473.82 392.324 474.843 392.324 474.843L394.303 441.897L395.589 425.506C395.589 425.506 397.238 437.543 398.326 448.295C399.282 457.661 401.525 466.136 404.064 483.582C406.241 498.719 411.979 529.884 411.979 529.884C418.311 533.578 422.895 530.247 422.895 530.247C422.895 530.247 426.985 490.013 425.303 476.887Z"
          fill="#6C6D6D"
        />
        <path
          d="M395.557 425.507C395.557 425.507 397.206 437.544 398.294 448.295C398.756 452.813 399.514 457.133 400.47 462.311C400.47 462.311 399.613 442.293 399.943 432.828C400.273 423.363 401.229 413.139 401.229 413.139C413.827 407.797 416.432 400.113 416.432 400.113C407.099 408.094 397.239 410.534 397.239 410.534L395.557 425.507Z"
          fill="#2C2C2C"
        />
        <path
          d="M416.532 276.639C411.98 276.87 408.584 278.024 407.99 276.705C407.528 275.649 406.968 269.581 406.935 269.581C407.462 268.262 407.924 266.844 407.924 266.844C413.662 263.315 417.752 257.346 418.51 250.157C419.796 237.822 410.826 226.808 398.525 225.521C386.949 224.301 378.408 232.447 376.132 243.66C374.912 249.167 373.263 260.908 376.561 269.977C378.408 275.056 379.991 277.298 382.365 278.09C383.19 278.255 387.609 278.156 389.225 277.991C389.225 277.991 389.852 281.421 390.247 283.597C390.676 285.807 390.511 286.961 386.125 289.665C381.739 292.37 392.754 297.91 399.91 297.349C407.1 296.789 415.179 292.469 417.389 287.818C419.895 282.608 419.665 276.474 416.532 276.639Z"
          fill="#A55F38"
        />
        <path
          d="M386.123 289.6C385.958 289.698 385.892 289.797 385.76 289.896L392.026 292.04L410.561 289.171L414.881 278.123C414.881 278.123 414.716 277.595 414.452 276.804C410.956 277.166 408.483 277.826 407.988 276.672C407.658 275.88 407.23 272.22 407.032 270.472C403.701 271.065 399.776 271.758 398.82 271.791C397.105 271.857 391.202 263.15 391.202 263.15C391.202 263.15 390.378 270.439 389.586 272.45C388.795 274.462 383.386 277.595 381.407 277.562C381.704 277.727 382.001 277.859 382.331 277.991C383.155 278.156 387.574 278.057 389.19 277.892C389.19 277.892 389.817 281.322 390.213 283.498C390.674 285.741 390.509 286.895 386.123 289.6Z"
          fill="#A55F38"
        />
        <path
          d="M418.642 236.108C418.081 233.437 416.201 229.974 401.79 225.918C388.004 222.059 377.22 220.41 374.549 222.191C371.911 223.972 371.251 237.592 384.278 244.089C384.805 245.078 385.135 246.233 385.135 247.816C385.135 249.926 384.904 251.608 385.135 253.917C385.465 257.182 388.961 257.413 388.961 257.413C388.961 257.413 388.994 255.533 388.994 251.641C390.214 248.937 394.93 248.244 396.645 252.004C398.36 255.764 397.403 258.897 396.216 261.172C394.699 264.041 392.127 264.272 391.269 263.25C391.269 266.515 391.896 271.396 395.557 275.518C400.438 276.903 405.252 274.792 407.363 272.946C407.891 271.494 409.573 268.856 411.749 265.36C414.421 261.106 417.191 258.336 418.675 251.443C419.994 245.111 419.697 241.286 418.642 236.108Z"
          fill="black"
        />
        <path
          d="M409.936 277.331C411.189 280.497 407.99 284.323 399.416 287.027C390.841 289.731 390.083 286.269 390.083 286.269C390.083 286.269 377.518 292.007 373.428 294.843C368.284 298.438 366.008 308.859 365.316 326.404C364.524 346.752 364.458 376.895 365.118 382.105C365.118 382.105 374.747 391.702 387.049 390.68C399.35 389.657 420.061 378.774 425.073 370.365C424.941 352.523 422.864 349.621 425.733 339.365C432.329 315.851 435.824 306.221 432.625 290.589C429.987 277.694 426.261 276.111 421.182 276.243C416.037 276.375 409.936 277.331 409.936 277.331Z"
          fill="#F5FBFB"
        />
        <path
          d="M407.725 275.584C405.944 277.827 399.744 282.741 390.147 283.005C388.3 282.708 387.278 286.269 386.223 288.05C386.223 288.05 390.543 291.579 400.14 289.139C409.737 286.698 413.133 279.641 412.309 277.002C412.309 277.002 409.242 273.639 407.725 275.584Z"
          fill="#E4F2F2"
        />
        <path
          d="M345.956 346.522C356.047 349.062 358.422 342.697 359.741 337.42C362.94 324.657 364.688 313.115 367.062 305.892C369.865 297.351 372.833 295.999 376.989 294.317C381.87 292.371 386.058 296.493 384.442 307.344C382.529 320.205 379.99 329.241 375.175 344.478C373.922 348.435 371.086 355.526 366.897 358.922C361.687 363.144 353.838 362.946 341.965 360.011C336.887 358.758 331.346 355.723 321.782 351.271C319.21 350.084 317.198 349.26 312.284 346.984C307.337 344.676 302.226 340.85 299.62 337.09C297.015 333.331 296.685 331.583 297.213 330.726C297.872 329.637 299.06 329.901 300.412 331.451C301.797 333.034 303.809 335.87 307.667 338.179C307.667 338.179 304.468 334.881 302.753 332.737C301.038 330.594 299.686 328.252 298.928 326.504C298.004 324.328 299.884 321.36 301.335 322.91C302.786 324.46 303.446 326.043 306.051 329.176C308.426 332.012 310.734 333.628 310.734 333.628C310.734 333.628 308.096 330.066 306.414 326.702C304.765 323.305 304.765 321.59 304.831 320.436C304.897 319.282 306.513 317.93 308.03 320.106C309.382 322.052 310.273 325.086 313.439 328.384C315.747 330.791 317.693 332.144 317.759 331.484C317.825 330.824 316.374 329.505 315.549 326.735C314.758 324.064 315.582 320.997 317.099 320.667C318.616 320.337 318.352 320.436 319.573 323.041C320.793 325.647 322.706 327.592 324.157 331.385C325.443 334.749 326.003 336.101 328.312 338.542C330.851 341.18 336.359 344.082 345.956 346.522Z"
          fill="#A55F38"
        />
        <path
          d="M380.749 292.568C374.021 291.578 369.239 294.612 366.271 304.836C363.303 315.059 361.226 323.436 361.226 323.436C361.226 323.436 364.458 328.976 372.504 330.955C380.584 332.901 383.486 329.042 383.486 329.042C383.486 329.042 385.729 318.324 387.114 311.036C388.499 303.747 389.093 293.788 380.749 292.568Z"
          fill="#E4F2F2"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_165_3240"
          x="297"
          y="214.475"
          width="152.211"
          height="351.144"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="-4" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_165_3240"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_165_3240"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_165_3240"
          x1="269.688"
          y1="455.458"
          x2="396.466"
          y2="73.2097"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF5B5B" />
          <stop offset="0.760417" stopColor="#FFAFAF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_165_3240"
          x1="295.485"
          y1="418.119"
          x2="425.562"
          y2="418.119"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF787C" />
          <stop offset="1" stopColor="#FFFCFC" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_165_3240"
          x1="491.435"
          y1="316.393"
          x2="358.856"
          y2="316.393"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7578" />
          <stop offset="1" stopColor="#FFD6D7" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_165_3240"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(162.053 370.679) rotate(90) scale(55.4495)"
        >
          <stop offset="0.338542" stopColor="#FF4E4E" />
          <stop offset="0.78125" stopColor="#FFB6B6" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_165_3240"
          x1="162.075"
          y1="110.021"
          x2="162.075"
          y2="187.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.302083" stopColor="#FFB1B3" />
          <stop offset="1" stopColor="#FF7679" />
        </linearGradient>
      </defs>
    </svg>
  );
};
Login.displayName = "Login";

const ExternalContent = ({ ...props }: React.ComponentProps<"svg">) => {
  return (
    <svg
      data-slot="media-external-content"
      data-testid="media-external-content"
      width="483"
      height="385"
      viewBox="0 0 483 385"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.4"
        d="M242.819 117.57C210.629 117.622 201.3 136.837 200.452 149.314C191.618 152.304 172.233 159.834 165.369 166.035C158.505 172.235 164.527 189.378 168.395 197.174C196.928 201.248 217.702 186.607 237.555 208.084C246.3 217.543 342.035 235.503 363.342 214.896L363.925 215.021C392.287 221.129 442.94 232.037 465.343 194.699C493.54 147.704 398.255 131.371 386.605 127.424C363.882 119.725 371.606 80.8636 318.707 71.8922C265.807 62.9209 269.148 117.528 242.819 117.57Z"
        fill="#1E7ED7"
      />
      <g filter="url(#filter0_d_165_5198)">
        <path
          d="M44 209C44 236.439 58.5764 270.16 110.119 270.16"
          stroke="#479BFE"
          strokeOpacity="0.3"
          strokeWidth="80.004"
          strokeLinecap="round"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M266.267 124C286.662 279.008 30.6963 240.256 215.277 228.018"
        stroke="#AAAAAA"
        strokeOpacity="0.3"
        strokeWidth="212.581"
        strokeLinecap="round"
      />
      <path
        d="M153 252L32.2315 252L32.2315 167.927L93.7249 47L169 47"
        stroke="#AAAAAA"
        strokeWidth="3.39295"
        strokeLinecap="round"
        strokeDasharray="9.8 9.8"
      />
      <path
        d="M247 36.1379C247 56.0963 211 104 211 104C209.561 102.556 175 56.0963 175 36.1379C175 16.1795 191.118 0 211 0C230.882 0 247 16.1795 247 36.1379Z"
        fill="url(#paint0_linear_165_5198)"
      />
      <path
        d="M229.852 27.2302C232.609 37.5193 226.503 48.0952 216.213 50.8521C205.924 53.6091 195.348 47.5031 192.592 37.214C189.835 26.9249 195.941 16.349 206.23 13.5921C216.519 10.8351 227.095 16.9411 229.852 27.2302Z"
        fill="white"
      />
      <path
        d="M199 252.5C199 265.479 188.479 276 175.5 276C162.521 276 152 265.479 152 252.5C152 239.521 162.521 229 175.5 229C188.479 229 199 239.521 199 252.5Z"
        fill="#8D8A8A"
      />
      <path
        d="M314 309.5C314 322.479 303.479 333 290.5 333C277.521 333 267 322.479 267 309.5C267 296.521 277.521 286 290.5 286C303.479 286 314 296.521 314 309.5Z"
        fill="#8D8A8A"
      />
      <g filter="url(#filter1_d_165_5198)">
        <path
          d="M66.1932 151.27C65.6541 156.036 59.9514 176.577 61.1714 183.642C62.3914 190.678 81.7978 202.453 81.7978 202.453L84.4932 190.395L73.7402 179.869L76.6341 159.895L66.1932 151.27Z"
          fill="#A55F38"
        />
        <path
          d="M81.2314 128.175C78.451 126.983 73.2873 126.699 70.4217 131.437C67.5562 136.176 64.6055 152.404 64.3218 155.185C64.3218 155.185 68.3222 160.717 74.3371 159.809L81.2314 128.175Z"
          fill="#E4F2F2"
        />
        <path
          d="M78.5074 346.582C78.5074 346.582 78.2805 348.681 77.6563 351.348C77.1456 353.419 77.0604 356.086 79.3586 356.853C81.6851 357.59 84.3236 357.363 85.8274 355.349C87.6715 352.852 88.6646 349.731 91.3315 347.291C93.9134 344.965 97.1195 342.326 98.0274 338.609C98.8785 335.261 98.3394 333.162 96.0413 332.821C93.1473 332.396 88.5511 334.836 86.1962 336.566C84.4939 337.786 78.5074 346.582 78.5074 346.582Z"
          fill="#3F3F41"
        />
        <path
          d="M105.063 356.313C105.063 356.313 104.892 358.98 104.722 361.108C104.552 363.235 103.814 366.612 104.495 368.201C105.176 369.761 108.666 370.924 112.78 370.896C115.447 370.867 120.61 372.939 122.455 374.527C125.065 376.797 131.08 377.705 134.598 376.599C138.144 375.492 142.06 373.847 142.656 372.229C143.251 370.612 141.407 369.789 132.782 365.846C124.157 361.902 117.802 359.178 114.454 354.61L105.063 356.313Z"
          fill="#3F3F41"
        />
        <path
          d="M76.4077 300.734C77.883 289.442 80.2095 282.746 80.2095 282.746C80.2095 282.746 79.0746 267.226 78.5072 252.501C77.8546 235.79 72.0667 221.094 76.6346 207.759L128.187 219.221C128.187 219.221 125.066 285.839 124.385 293.896C124.016 298.265 123.874 302.635 122.058 312.593C119.703 325.531 115.873 356.286 115.873 356.286C110.426 359.464 105.035 356.314 105.035 356.314C105.035 356.314 103.645 318.807 104.014 309.472C104.439 298.095 104.78 298.975 104.78 298.975L103.077 270.631L101.971 256.53C101.971 256.53 100.552 266.886 99.6159 276.135C98.7931 284.193 96.8639 291.485 94.6792 306.493C92.8067 319.516 87.8699 346.327 87.8699 346.327C82.4225 349.505 78.4788 346.64 78.4788 346.64C78.4788 346.64 74.9607 312.026 76.4077 300.734Z"
          fill="#6C6D6D"
        />
        <path
          d="M101.998 256.53C101.998 256.53 100.579 266.886 99.6432 276.135C99.246 280.022 98.5934 283.739 97.7707 288.193C97.7707 288.193 98.5083 270.971 98.2246 262.829C97.9409 254.686 97.1181 245.891 97.1181 245.891C86.28 241.294 84.0386 234.684 84.0386 234.684C92.0679 241.55 100.551 243.649 100.551 243.649L101.998 256.53Z"
          fill="#2C2C2C"
        />
        <path
          d="M83.9537 128.458C87.869 128.656 90.7913 129.649 91.302 128.514C91.6992 127.606 92.1815 122.386 92.2098 122.386C91.7559 121.251 91.3587 120.031 91.3587 120.031C86.422 116.995 82.9039 111.86 82.2513 105.675C81.1448 95.0637 88.862 85.5876 99.4447 84.4811C109.403 83.4313 116.752 90.4392 118.709 100.086C119.759 104.824 121.178 114.924 118.34 122.726C116.752 127.096 115.39 129.025 113.347 129.706C112.638 129.848 108.836 129.763 107.446 129.621C107.446 129.621 106.907 132.572 106.566 134.444C106.197 136.345 106.339 137.338 110.113 139.665C113.886 141.991 104.41 146.758 98.2531 146.275C92.068 145.793 85.1169 142.076 83.216 138.076C81.0597 133.593 81.2583 128.316 83.9537 128.458Z"
          fill="#A55F38"
        />
        <path
          d="M110.114 139.609C110.256 139.694 110.312 139.779 110.426 139.864L105.035 141.708L89.0901 139.24L85.3734 129.735C85.3734 129.735 85.5151 129.281 85.7421 128.601C88.7496 128.913 90.8775 129.48 91.3031 128.487C91.5868 127.806 91.9556 124.657 92.1258 123.153C94.9914 123.664 98.3677 124.26 99.1905 124.288C100.666 124.345 105.744 116.854 105.744 116.854C105.744 116.854 106.454 123.125 107.135 124.855C107.816 126.586 112.469 129.281 114.171 129.253C113.916 129.395 113.66 129.508 113.376 129.622C112.667 129.764 108.865 129.679 107.475 129.537C107.475 129.537 106.936 132.487 106.596 134.36C106.198 136.289 106.34 137.282 110.114 139.609Z"
          fill="#A55F38"
        />
        <path
          d="M82.1377 93.5894C82.6201 91.2912 84.2373 88.3122 96.6359 84.8224C108.495 81.5029 117.773 80.0843 120.071 81.6164C122.341 83.1485 122.908 94.8661 111.701 100.455C111.247 101.307 110.964 102.3 110.964 103.661C110.964 105.477 111.162 106.924 110.964 108.91C110.68 111.719 107.673 111.918 107.673 111.918C107.673 111.918 107.644 110.3 107.644 106.953C106.594 104.626 102.537 104.03 101.062 107.265C99.5865 110.499 100.409 113.194 101.431 115.152C102.736 117.62 104.949 117.819 105.686 116.939C105.686 119.748 105.147 123.947 101.998 127.494C97.7991 128.685 93.6568 126.87 91.841 125.281C91.387 124.032 89.94 121.763 88.0675 118.755C85.7693 115.095 83.3861 112.712 82.1093 106.782C80.9745 101.335 81.2298 98.0438 82.1377 93.5894Z"
          fill="black"
        />
        <path
          d="M89.6279 129.054C88.5497 131.778 91.3018 135.069 98.6785 137.395C106.055 139.722 106.708 136.743 106.708 136.743C106.708 136.743 117.517 141.679 121.036 144.119C125.462 147.212 127.419 156.177 128.015 171.271C128.696 188.777 128.753 214.709 128.185 219.192C128.185 219.192 119.901 227.448 109.318 226.568C98.7353 225.689 80.9176 216.326 76.6051 209.091C76.7185 193.742 78.506 191.245 76.0377 182.421C70.3633 162.192 67.3559 153.908 70.1079 140.459C72.3777 129.366 75.5837 128.004 79.953 128.117C84.379 128.231 89.6279 129.054 89.6279 129.054Z"
          fill="#F5FBFB"
        />
        <path
          d="M91.5297 127.55C93.0618 129.48 98.3958 133.707 106.652 133.934C108.241 133.679 109.12 136.743 110.028 138.275C110.028 138.275 106.312 141.311 98.0553 139.211C89.7991 137.112 86.8768 131.04 87.5861 128.77C87.5861 128.77 90.2246 125.877 91.5297 127.55Z"
          fill="#E4F2F2"
        />
        <path
          d="M144.67 188.58C135.988 190.764 133.946 185.289 132.811 180.749C130.059 169.769 128.555 159.839 126.512 153.625C124.101 146.277 121.547 145.114 117.972 143.667C113.773 141.993 110.17 145.539 111.56 154.874C113.206 165.939 115.39 173.713 119.533 186.821C120.611 190.225 123.051 196.325 126.654 199.248C131.137 202.879 137.889 202.709 148.103 200.184C152.472 199.106 157.239 196.495 165.467 192.665C167.68 191.644 169.411 190.935 173.638 188.977C177.894 186.991 182.291 183.7 184.533 180.465C186.774 177.231 187.058 175.727 186.604 174.99C186.037 174.053 185.015 174.28 183.852 175.614C182.66 176.976 180.93 179.416 177.61 181.402C177.61 181.402 180.362 178.564 181.837 176.72C183.313 174.876 184.476 172.862 185.129 171.358C185.923 169.485 184.306 166.932 183.057 168.265C181.809 169.599 181.242 170.961 179 173.656C176.958 176.096 174.971 177.486 174.971 177.486C174.971 177.486 177.241 174.422 178.688 171.528C180.107 168.606 180.107 167.131 180.05 166.137C179.993 165.144 178.603 163.981 177.298 165.854C176.135 167.528 175.369 170.138 172.645 172.975C170.659 175.046 168.985 176.209 168.928 175.642C168.871 175.075 170.12 173.94 170.829 171.556C171.51 169.258 170.801 166.62 169.496 166.336C168.191 166.052 168.418 166.137 167.368 168.379C166.318 170.62 164.672 172.294 163.424 175.557C162.318 178.451 161.835 179.614 159.849 181.714C157.665 183.983 152.926 186.48 144.67 188.58Z"
          fill="#A55F38"
        />
        <path
          d="M114.737 142.162C120.525 141.311 124.639 143.921 127.192 152.716C129.746 161.512 131.533 168.718 131.533 168.718C131.533 168.718 128.753 173.485 121.83 175.187C114.879 176.861 112.382 173.541 112.382 173.541C112.382 173.541 110.453 164.321 109.261 158.05C108.07 151.78 107.559 143.212 114.737 142.162Z"
          fill="#E4F2F2"
        />
      </g>
      <path
        d="M270 215.5C270 221.851 264.851 227 258.5 227C252.149 227 247 221.851 247 215.5C247 209.149 252.149 204 258.5 204C264.851 204 270 209.149 270 215.5Z"
        fill="#8D8A8A"
      />
      <g filter="url(#filter2_d_165_5198)">
        <path
          d="M263.276 71C263.276 38.139 289.344 11.5 321.5 11.5C353.657 11.5 296.186 20.1201 296.186 71C296.186 121.88 353.657 130.5 321.5 130.5C289.344 130.5 263.276 103.861 263.276 71Z"
          fill="white"
        />
      </g>
      <path
        d="M314 309.5C314 322.479 303.479 333 290.5 333C277.521 333 267 322.479 267 309.5C267 296.521 277.521 286 290.5 286C303.479 286 314 296.521 314 309.5Z"
        fill="#8D8A8A"
      />
      <defs>
        <filter
          id="filter0_d_165_5198"
          x="-0.00195312"
          y="168.998"
          width="154.123"
          height="149.164"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_165_5198"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_165_5198"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_165_5198"
          x="61.001"
          y="81"
          width="131.786"
          height="303.069"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="4" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_165_5198"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_165_5198"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_165_5198"
          x="259.276"
          y="11.5"
          width="76"
          height="127"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_165_5198"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_165_5198"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_165_5198"
          x1="210.973"
          y1="20.2222"
          x2="210.973"
          y2="64.7593"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.302083" stopColor="#309CFF" />
          <stop offset="1" stopColor="#0043F0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
ExternalContent.displayName = "ExternalContent";

const NotFound = ({ ...props }: React.ComponentProps<"svg">) => {
  return (
    <svg
      data-slot="media-not-found"
      data-testid="media-not-found"
      width="419"
      height="341"
      viewBox="0 0 419 341"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M46 209C46 236.439 60.5764 270.16 112.119 270.16"
        stroke="#5038E4"
        strokeOpacity="0.3"
        strokeWidth="80.004"
        strokeLinecap="round"
      />
      <path
        d="M271.267 116C291.662 271.008 35.6963 232.256 220.277 220.018"
        stroke="#AAAAAA"
        strokeOpacity="0.3"
        strokeWidth="212.581"
        strokeLinecap="round"
      />
      <rect
        x="70.8311"
        y="181.98"
        width="26.4476"
        height="233.659"
        transform="rotate(-60 70.8311 181.98)"
        fill="#9074FF"
      />
      <rect
        x="26.001"
        y="293.961"
        width="26.9606"
        height="195.068"
        transform="rotate(-90 26.001 293.961)"
        fill="#9277FF"
      />
      <rect
        x="161"
        y="149.636"
        width="27.77"
        height="212.242"
        transform="rotate(-45 161 149.636)"
        fill="#6842FF"
      />
      <rect
        x="272"
        y="121.627"
        width="27.1088"
        height="228.393"
        transform="rotate(-32.6542 272 121.627)"
        fill="#6842FF"
      />
      <rect
        x="209"
        y="142.891"
        width="27.1088"
        height="219.515"
        transform="rotate(-41.2977 209 142.891)"
        fill="#7D68FF"
      />
      <path
        d="M6.00004 253L41.3057 253L41.3057 168.517L99.6184 47L171 47"
        stroke="#AAAAAA"
        strokeWidth="3.39295"
        strokeLinecap="round"
        strokeDasharray="9.8 9.8"
      />
      <path
        d="M405.972 132C405.972 152.689 409.934 31.5 322.923 31.5C235.913 31.5 243.5 182 231 199.5C218.5 217 44 95.4997 157.048 251L13 251"
        stroke="url(#paint0_linear_4459_26936)"
        strokeWidth="25.1252"
        strokeLinecap="round"
      />
      <path
        d="M323.573 140C313.373 140 303.402 143.083 294.92 148.859C286.439 154.635 279.829 162.844 275.926 172.449C272.022 182.054 271.001 192.623 272.991 202.819C274.981 213.016 279.893 222.382 287.105 229.733C294.318 237.085 303.507 242.091 313.511 244.119C323.516 246.147 333.885 245.106 343.309 241.128C352.733 237.149 360.787 230.412 366.454 221.768C372.121 213.124 375.146 202.961 375.146 192.565L345.299 192.565C345.299 196.944 344.025 201.225 341.637 204.867C339.25 208.508 335.857 211.347 331.887 213.023C327.917 214.699 323.549 215.137 319.334 214.283C315.12 213.428 311.249 211.319 308.21 208.223C305.172 205.126 303.103 201.18 302.264 196.885C301.426 192.589 301.856 188.137 303.501 184.091C305.145 180.044 307.93 176.586 311.503 174.153C315.075 171.72 319.276 170.421 323.573 170.421L323.573 140Z"
        fill="url(#paint1_linear_4459_26936)"
      />
      <circle
        cx="159.945"
        cy="276.944"
        r="43.9691"
        transform="rotate(-91.2854 159.945 276.944)"
        fill="url(#paint2_radial_4459_26936)"
      />
      <rect
        x="342.566"
        y="166.92"
        width="27.7536"
        height="127.666"
        fill="#FFE4E4"
        fillOpacity="0.6"
      />
      <path
        d="M249 36.1379C249 56.0963 213 104 213 104C211.561 102.556 177 56.0963 177 36.1379C177 16.1795 193.118 0 213 0C232.882 0 249 16.1795 249 36.1379Z"
        fill="url(#paint3_linear_4459_26936)"
      />
      <path
        d="M231.852 27.2302C234.609 37.5193 228.503 48.0952 218.213 50.8521C207.924 53.6091 197.348 47.5031 194.592 37.214C191.835 26.9249 197.941 16.349 208.23 13.5921C218.519 10.8351 229.095 16.9411 231.852 27.2302Z"
        fill="white"
      />
      <circle cx="107.085" cy="295.084" r="13.0838" fill="#8D8A8A" />
      <path
        d="M383.94 132.193C384.436 136.586 389.693 155.519 388.568 162.031C387.444 168.516 369.557 179.369 369.557 179.369L367.072 168.255L376.983 158.553L374.316 140.143L383.94 132.193Z"
        fill="#A55F38"
      />
      <path
        d="M370.078 110.906C372.641 109.808 377.4 109.546 380.042 113.913C382.683 118.28 385.403 133.239 385.664 135.801C385.664 135.801 381.977 140.901 376.433 140.064L370.078 110.906Z"
        fill="#E4F2F2"
      />
      <path
        d="M372.589 312.215C372.589 312.215 372.798 314.15 373.373 316.608C373.844 318.517 373.923 320.975 371.804 321.682C369.66 322.361 367.228 322.152 365.842 320.295C364.142 317.994 363.227 315.118 360.769 312.869C358.389 310.724 355.434 308.292 354.597 304.866C353.813 301.781 354.309 299.846 356.428 299.532C359.095 299.139 363.332 301.388 365.502 302.984C367.071 304.108 372.589 312.215 372.589 312.215Z"
        fill="#3F3F41"
      />
      <path
        d="M348.113 321.185C348.113 321.185 348.27 323.643 348.427 325.604C348.584 327.566 349.264 330.678 348.636 332.142C348.009 333.58 344.792 334.652 341 334.626C338.542 334.6 333.783 336.509 332.083 337.974C329.677 340.066 324.133 340.903 320.89 339.883C317.621 338.863 314.013 337.346 313.463 335.855C312.914 334.365 314.614 333.606 322.564 329.971C330.514 326.336 336.372 323.826 339.457 319.616L348.113 321.185Z"
        fill="#3F3F41"
      />
      <path
        d="M374.525 269.956C373.165 259.548 371.021 253.376 371.021 253.376C371.021 253.376 372.067 239.072 372.59 225.499C373.192 210.097 378.526 196.55 374.316 184.26L326.8 194.825C326.8 194.825 329.676 256.227 330.304 263.654C330.644 267.681 330.775 271.708 332.448 280.887C334.619 292.812 338.149 321.159 338.149 321.159C343.17 324.088 348.139 321.186 348.139 321.186C348.139 321.186 349.42 286.614 349.08 278.011C348.688 267.524 348.374 268.335 348.374 268.335L349.943 242.21L350.963 229.213C350.963 229.213 352.271 238.758 353.134 247.283C353.892 254.71 355.67 261.431 357.684 275.265C359.41 287.268 363.96 311.98 363.96 311.98C368.981 314.909 372.616 312.268 372.616 312.268C372.616 312.268 375.859 280.364 374.525 269.956Z"
        fill="#6C6D6D"
      />
      <path
        d="M350.938 229.213C350.938 229.213 352.245 238.758 353.108 247.284C353.474 250.866 354.076 254.292 354.834 258.398C354.834 258.398 354.154 242.524 354.416 235.019C354.677 227.514 355.435 219.407 355.435 219.407C365.425 215.17 367.491 209.077 367.491 209.077C360.09 215.406 352.271 217.341 352.271 217.341L350.938 229.213Z"
        fill="#2C2C2C"
      />
      <path
        d="M367.57 111.167C363.961 111.35 361.267 112.265 360.797 111.219C360.43 110.382 359.986 105.571 359.96 105.571C360.378 104.525 360.744 103.4 360.744 103.4C365.294 100.602 368.537 95.8686 369.139 90.1677C370.159 80.3873 363.045 71.653 353.291 70.6331C344.112 69.6655 337.339 76.1248 335.535 85.0161C334.567 89.3833 333.26 98.6929 335.875 105.884C337.339 109.912 338.594 111.69 340.477 112.318C341.131 112.448 344.635 112.37 345.917 112.239C345.917 112.239 346.413 114.959 346.727 116.685C347.067 118.437 346.937 119.352 343.458 121.497C339.98 123.641 348.715 128.034 354.39 127.59C360.09 127.145 366.497 123.719 368.25 120.032C370.237 115.9 370.054 111.036 367.57 111.167Z"
        fill="#A55F38"
      />
      <path
        d="M343.457 121.445C343.327 121.523 343.274 121.602 343.17 121.68L348.138 123.38L362.835 121.105L366.261 112.344C366.261 112.344 366.13 111.926 365.921 111.298C363.149 111.586 361.188 112.109 360.795 111.194C360.534 110.566 360.194 107.663 360.037 106.277C357.396 106.748 354.284 107.297 353.525 107.323C352.166 107.376 347.485 100.472 347.485 100.472C347.485 100.472 346.831 106.251 346.203 107.846C345.576 109.441 341.287 111.926 339.718 111.9C339.953 112.03 340.188 112.135 340.45 112.24C341.104 112.37 344.608 112.292 345.889 112.161C345.889 112.161 346.386 114.881 346.7 116.607C347.066 118.385 346.935 119.3 343.457 121.445Z"
        fill="#A55F38"
      />
      <path
        d="M369.243 79.0281C368.798 76.9099 367.308 74.1641 355.88 70.9475C344.948 67.8879 336.397 66.5803 334.279 67.9925C332.187 69.4046 331.664 80.2049 341.993 85.3566C342.412 86.1411 342.673 87.0564 342.673 88.3117C342.673 89.9853 342.49 91.319 342.673 93.1496C342.935 95.7385 345.707 95.9216 345.707 95.9216C345.707 95.9216 345.733 94.431 345.733 91.3452C346.701 89.2008 350.44 88.6517 351.8 91.6329C353.16 94.6141 352.402 97.0984 351.46 98.9028C350.257 101.178 348.217 101.361 347.537 100.55C347.537 103.139 348.034 107.01 350.937 110.278C354.807 111.377 358.625 109.703 360.299 108.239C360.717 107.088 362.051 104.996 363.777 102.224C365.895 98.8505 368.092 96.6538 369.269 91.1883C370.315 86.1673 370.08 83.1338 369.243 79.0281Z"
        fill="black"
      />
      <path
        d="M362.34 111.717C363.334 114.227 360.797 117.261 353.998 119.405C347.199 121.549 346.597 118.803 346.597 118.803C346.597 118.803 336.634 123.354 333.391 125.603C329.311 128.453 327.507 136.717 326.958 150.629C326.33 166.764 326.278 190.666 326.801 194.798C326.801 194.798 334.437 202.408 344.191 201.597C353.946 200.787 370.368 192.157 374.343 185.488C374.239 171.341 372.591 169.039 374.866 160.906C380.096 142.261 382.868 134.625 380.332 122.229C378.24 112.004 375.285 110.749 371.257 110.854C367.178 110.958 362.34 111.717 362.34 111.717Z"
        fill="#F5FBFB"
      />
      <path
        d="M360.587 110.331C359.174 112.109 354.258 116.006 346.648 116.215C345.184 115.98 344.373 118.804 343.536 120.216C343.536 120.216 346.962 123.014 354.572 121.079C362.182 119.144 364.875 113.547 364.222 111.455C364.222 111.455 361.79 108.788 360.587 110.331Z"
        fill="#E4F2F2"
      />
      <path
        d="M311.606 166.582C319.608 168.596 321.491 163.548 322.537 159.364C325.074 149.244 326.46 140.091 328.343 134.364C330.565 127.591 332.919 126.519 336.214 125.185C340.084 123.642 343.405 126.911 342.124 135.515C340.607 145.714 338.594 152.879 334.776 164.961C333.782 168.099 331.533 173.721 328.212 176.415C324.08 179.762 317.856 179.605 308.442 177.278C304.414 176.284 300.021 173.878 292.437 170.348C290.398 169.406 288.802 168.752 284.906 166.948C280.983 165.118 276.93 162.084 274.864 159.103C272.798 156.122 272.537 154.736 272.955 154.056C273.478 153.193 274.419 153.402 275.492 154.631C276.59 155.886 278.185 158.135 281.245 159.966C281.245 159.966 278.708 157.351 277.348 155.651C275.988 153.951 274.916 152.094 274.315 150.708C273.583 148.982 275.073 146.629 276.224 147.858C277.374 149.087 277.897 150.342 279.963 152.827C281.846 155.076 283.677 156.357 283.677 156.357C283.677 156.357 281.585 153.533 280.251 150.865C278.944 148.172 278.943 146.812 278.996 145.897C279.048 144.981 280.329 143.909 281.532 145.635C282.605 147.178 283.311 149.584 285.821 152.199C287.652 154.108 289.195 155.18 289.247 154.657C289.299 154.134 288.149 153.088 287.495 150.891C286.867 148.773 287.521 146.341 288.724 146.08C289.927 145.818 289.718 145.897 290.685 147.962C291.653 150.028 293.17 151.571 294.32 154.579C295.34 157.246 295.785 158.318 297.615 160.253C299.629 162.346 303.996 164.647 311.606 166.582Z"
        fill="#A55F38"
      />
      <path
        d="M339.196 123.798C333.861 123.014 330.07 125.419 327.716 133.526C325.362 141.633 323.715 148.275 323.715 148.275C323.715 148.275 326.278 152.669 332.658 154.238C339.065 155.781 341.367 152.721 341.367 152.721C341.367 152.721 343.145 144.222 344.243 138.443C345.342 132.663 345.812 124.766 339.196 123.798Z"
        fill="#E4F2F2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4459_26936"
          x1="246.886"
          y1="252.221"
          x2="267.282"
          y2="109.932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.760417" stopColor="#3A3A3A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4459_26936"
          x1="272"
          y1="192.565"
          x2="375.146"
          y2="192.565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8C8C8C" />
          <stop offset="1" stopColor="#FFFCFC" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_4459_26936"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(159.945 276.944) rotate(90) scale(43.9691)"
        >
          <stop offset="0.338542" stopColor="#676767" />
          <stop offset="0.78125" stopColor="#959292" />
        </radialGradient>
        <linearGradient
          id="paint3_linear_4459_26936"
          x1="212.973"
          y1="20.2222"
          x2="212.973"
          y2="64.7593"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.302083" stopColor="#A0A0A0" />
          <stop offset="1" stopColor="#5F5E5E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
NotFound.displayName = "NotFound";

export { Login, ExternalContent, NotFound };
